import React from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function PublicLayout({ children }) {
  return (
    <div className="relative min-h-screen bg-[#0A0A0A] text-white">
      <Nav />
      <main className="pt-16 md:pt-20">{children}</main>
      <Footer />
    </div>
  );
}
